<div class="row mx-0">
    <div class="col-6 ps-0">
        <div class="content-container">
            <div class="title d-inline-flex w-100 justify-content-between">
                <div class="fw-bold">
                    Signature:
                </div>
                <div>
                    <button class="mwp-button" [disabled]="!signatureValid" >
                        Signature Test Complete Button
                    </button>
                </div>
            </div>
            <div class="content">
                <mwp-signature (emitCancel)="cancelSignature()" (emitComplete)="completeSignature($event)" />
            </div>
        </div>
    </div>
    <div class="col-2">
        <div class="content-container">
            <div class="title d-inline-flex w-100 justify-content-between">
                <div class="fw-bold">
                    Verify Code:
                </div>
            </div>
            <div class="content">
                <form [formGroup]="verifyForm" autocomplete="off">
                    <div class="mb-1 fw-bold">
                        
                    </div>
                    <div class="mb-2">
                        <mwp-verify-code [form]="verifyForm" nameForRadioControl="verifyInput" [useFixedWidth]="true" />
                    </div>
                    <div>
                        <button class="mwp-button" [disabled]="verifyForm.invalid" >
                            Veirfy Code
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>